var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEssence = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 5.67L20 4.56l-6-1-5.61 2 .51 1.29 4.52-1.21v.61a1.47 1.47 0 00.86 1.35l3.59 1.2a.93.93 0 001.23-.55l.66-1.54A9.83 9.83 0 117.51 9l.08-.09-.74-.6a10.79 10.79 0 1013-2.62zm-1.15 1.77c-.23.52-.44.76-1 .58l-2.89-1A1 1 0 0114.05 6v-.47l4.83 1.58z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17a4 4 0 01-8 0c0-2.23 4-6.81 4-6.81s4 4.56 4 6.81z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEssence, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/essence.db9ed065.svg";
export { ForwardRef as ReactComponent };